import { useState } from 'react';
import {
  DndContext,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import { arrayMove, SortableContext } from '@dnd-kit/sortable';

import BacklogContent from './BacklogContent';
import SprintContent from './SprintContent';
import { structuredData } from '../../utils/backlogData';

const BacklogContainer = () => {
  const [allData, setAllData] = useState(structuredData);

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (!over) return;

    const activeId = active.id;
    const overId = over.id;

    let sourceSectionIndex, sourceIssueIndex;
    let sourceSection, destinationSection;

    allData.forEach((section, secIndex) => {
      section.issues.forEach((issue, issueIndex) => {
        if (issue.id === activeId) {
          sourceSection = section;
          sourceSectionIndex = secIndex;
          sourceIssueIndex = issueIndex;
        }
      });
    });

    if (!sourceSection) return;

    let destinationSectionIndex, destinationIssueIndex;

    allData.forEach((section, secIndex) => {
      if (section.id === overId) {
        destinationSection = section;
        destinationSectionIndex = secIndex;
        destinationIssueIndex = section.issues.length;
      }
      section.issues.forEach((issue, issueIndex) => {
        if (issue.id === overId) {
          destinationSection = section;
          destinationSectionIndex = secIndex;
          destinationIssueIndex = issueIndex;
        }
      });
    });

    if (!destinationSection) return;

    // Avoid unnecessary updates
    if (
      sourceSection.id === destinationSection.id &&
      sourceIssueIndex === destinationIssueIndex
    ) {
      return;
    }

    if (sourceSection.id === destinationSection.id) {
      const newData = [...allData];
      const sectionIndex = sourceSectionIndex;
      newData[sectionIndex].issues = arrayMove(
        newData[sectionIndex].issues,
        sourceIssueIndex,
        destinationIssueIndex,
      );
      setAllData(newData);
      return;
    }

    const newData = JSON.parse(JSON.stringify(allData));

    const [movedItem] = newData[sourceSectionIndex].issues.splice(
      sourceIssueIndex,
      1,
    );

    newData[destinationSectionIndex].issues.splice(
      destinationIssueIndex,
      0,
      movedItem,
    );

    setAllData(newData);
  };
  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 5 } }),
  );
  return (
    <DndContext onDragEnd={handleDragEnd} sensors={sensors}>
      <div className="h-[calc(100vh-150px)] overflow-y-auto">
        <div className="flex w-full flex-col gap-2 pb-2">
          {allData.map((item) =>
            item.type === 'backlog' ? (
              <SortableContext
                key={item.id}
                items={item.issues.map((issue) => issue.id)}
              >
                <BacklogContent
                  sectionId={item.id}
                  sectionData={item}
                  setAlldata={setAllData}
                  alldata={allData}
                />
              </SortableContext>
            ) : (
              <SortableContext
                key={item.id}
                items={item.issues.map((issue) => issue.id)}
              >
                <SprintContent
                  sectionId={item.id}
                  sectionData={item}
                  alldata={allData}
                  setAlldata={setAllData}
                />
              </SortableContext>
            ),
          )}
        </div>
      </div>
    </DndContext>
  );
};

export default BacklogContainer;
